// extracted by mini-css-extract-plugin
module.exports = {"userMenu":"UserMenu_userMenu__haCbM","userName":"UserMenu_userName__1lJmW"};